module.exports = __webpack_public_path__ + "static/media/work-4.515a808b.PNG";